import {
  useQueryStates,
  parseAsInteger,
  parseAsStringLiteral,
  parseAsString,
} from 'nuqs'

export const useI9ReverificationHubQueryState = () =>
  useQueryStates(
    {
      revGroupBy: parseAsStringLiteral([
        'state',
        'market',
        'expiration_bucket',
      ]).withDefault('expiration_bucket'),
      revExpirationDays: parseAsStringLiteral([
        '7',
        '14',
        '30',
        '60',
        '90',
      ]).withDefault('90'),
      revState: parseAsString,
      revMarket: parseAsString,
      revWorkerId: parseAsInteger,
      revWorkerSearch: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        revGroupBy: 'rev-group',
        revExpirationDays: 'rev-exp',
        revState: 'rev-state',
        revMarket: 'rev-market',
        revWorkerId: 'rev-worker-id',
        revWorkerSearch: 'rev-q',
      },
    }
  )
